import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@website/ui/skeleton";
const PRICE_TABLE_SKELETON = "PRICE_TABLE_SKELETON";
export const PriceCalendarSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Array.from({
      length: 7
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const fakeData = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><Skeleton height={24} shape="rectangle" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-4">{t1}<div className="flex w-full gap-2 overflow-hidden">{fakeData.map(_temp)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(_, index) {
  return <div className="border-outline-thin flex h-14 w-[88px] shrink-0 grow items-center rounded-lg border text-center md:w-[98px] lg:w-[104px]" key={PRICE_TABLE_SKELETON + index++}><Skeleton height={20} shape="rectangle" /></div>;
}